import { Layers, HeartHandshake, BadgeCheck, Smile, PiggyBank, ArrowRight } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";
import { WHY_POINTS } from "@/data/content";
import { useAnchorNav } from "@/lib/nav";

const ICONS = { Layers, HeartHandshake, BadgeCheck, Smile, PiggyBank };

const WhyTillvia = () => {
  const go = useAnchorNav();
  return (
    <section id="varfor-tillvia" className="bg-navy py-20 sm:py-28">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-5">
        <Reveal className="lg:col-span-2">
          <Eyebrow>Varför Tillvia</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Varför välja Tillvia?
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-cream/60">
            Vi gör det enkelt för små och växande företag att växa digitalt – utan krångel och utan dolda kostnader.
          </p>
          <a
            href="#kontakt"
            data-testid="why-cta-link"
            onClick={(e) => go(e, "kontakt")}
            className="mt-7 inline-flex items-center gap-2 font-display text-sm font-bold text-orange2 transition-colors hover:text-cream"
          >
            Boka kostnadsfritt möte <ArrowRight size={16} aria-hidden="true" />
          </a>
        </Reveal>

        <div className="lg:col-span-3">
          {WHY_POINTS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <Reveal key={p.title} delay={i * 0.06}>
                <div
                  data-testid={p.testId}
                  className={`flex items-start gap-5 py-6 ${i > 0 ? "border-t border-white/10" : ""}`}
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal text-cream">
                    <Icon size={20} strokeWidth={1.8} aria-hidden="true" />
                  </span>
                  <div>
                    <h3 className="font-display text-lg font-bold text-white">{p.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-cream/60 sm:text-base">{p.description}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyTillvia;
